import { LANDING_PAGE_EVENTS } from "@/constants/amplitude.constants";
import Amplitude from "@/shared/services/amplitude.service";
import { getCurrentURL, getScreenWidth } from "@/shared/utils/commons";
import { getUTMFieldsFromLocalStorage } from "@/shared/utils/utm.util";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import NProgress from "nprogress";
import { MouseEvent } from "react";
import Heading, { HeadingType } from "../atoms/Heading";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

export type OtherOfferingsMetaDataType = {
  name: string;
  moduleNum?:string;
  description: string;
  image: StaticImageData;
  slug?: string;
  path?: string;
  isNew?: boolean;
};

export type OtherOfferingsSectionPropType = {
  title: HeadingType;
  description?: string;
  otherOfferingsMetaData: OtherOfferingsMetaDataType[];
  gap: "gap-4 sm:gap-9" | "gap-4";
  moduleNum?:string;
  ctas?: CtaType[];
  subTitle?:string;
};

const OtherOfferingsSectionUS = ({
  title,
  description,
  otherOfferingsMetaData,
  gap,
  ctas,
  subTitle
}: OtherOfferingsSectionPropType) => {
  const router = useRouter();

  const handleDelayedHref = (e: MouseEvent, ctaHref: string, name: string) => {
    e.preventDefault();
    const { current_url, screen_width, utm_params, card_title } =
      LANDING_PAGE_EVENTS.OFFERING_CARD_TAPPED.PROPERTIES;
    new Amplitude().sendEvent({
      type: "lp_offerings_card_tapped",
      properties: {
        [current_url]: getCurrentURL(),
        [screen_width]: getScreenWidth(),
        [utm_params]: getUTMFieldsFromLocalStorage(),
        [card_title]: name,
      } as { [key: string]: string },
    });
    NProgress.start();
    setTimeout(() => {
      router.push(ctaHref);
    }, 500);
  };

  
  

  return (
    <div className="container flex flex-col gap-6 sm:gap-8">      
      <Heading
        heading={title}
        fontStyle="text-title-20 sm:text-title-32"
        align="text-center"
        as="h3"
      />
      
      {description && <p className="text-body text-center text-grey-4 mb-4">{description}</p>}

      <div
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-stretch justify-stretch text-left sm:text-center ${gap}`}
      >
        {otherOfferingsMetaData.map(
          ({ name, description, image, path, moduleNum }, index) => (
            <>
              {path ? (
                <Link
                  href={path}
                  className=""
                  onClick={(e) => handleDelayedHref(e, path, name)}
                >
                  <div className="h-16 w-16 flex-shrink-0 basis-16">
                    <Image src={image} alt={name} />
                  </div>
                  <div className="flex flex-grow flex-col gap-px">
                  
                    <h4 className="text-title-16 text-grey-4">{name}</h4>
                    <p className="text-body-12 text-grey-3">{description}</p>
                  </div>
                </Link>
              ) : (
                <div className="flex items-center bg-purple-0 flex-row-reverse px-3 pb-4 pt-6 flex-shrink flex-grow rounded-2xl sm:basis-48 sm:flex-col sm:items-center">
                  <div className={`flex-shrink-0 ${moduleNum ? '' : 'h-16 w-16'} basis-16`}>
                    <Image src={image} alt={name} />
                  </div>
                  <div className="flex flex-grow flex-col gap-px">
                  {moduleNum && <h4 className="text-title-16 text-center text-primary">{moduleNum}</h4>}
                    <h4 className="text-title-16 text-grey-4">{name}</h4>
                    <p className="text-body-12 text-grey-3">{description}</p>
                  </div>
                </div>
              )}
            </>
          )
        )}
      </div>
      {subTitle && <div className="mt-12 text-center">
        <p className="mb-4">{subTitle}</p>
        <CtaButtonGroup align="sm:center" ctas={ctas || []} affiliateButton={true} />
      </div>}
    </div>
  );
};

export default OtherOfferingsSectionUS;